import { createFileRoute } from "@tanstack/react-router";
import { LearnHubPage } from "#/features/learn/components/learn-hub-page";
import { learnPostsQueryOptions } from "#/features/learn/hooks/use-learn-posts";

export const Route = createFileRoute("/learn/")({
	// SSR: 목록을 캐시에 채워 섹션이 서버 HTML에 실린다 (실패 시 클라이언트가 에러 상태 → 재시도).
	loader: ({ context: { queryClient, locale } }) =>
		queryClient.prefetchQuery(learnPostsQueryOptions(locale)),
	component: LearnHubPage,
});
